module.exports = __webpack_public_path__ + "img/570.3740d7ba.jpg";